<template>
  <div class="contract-list">
	<div class="top-box" style="margin-top: 30px;">
		<span>关联商务合同总数：{{page.total}}条</span>
		<span>框架累计金额：{{tableData.length!=0?tableData[0].moneyCount:0}}元</span>
		<span>框架累计合作次数：{{tableData.length!=0?tableData[0].cooperationCount:0}}条</span>
	</div>
    <div class="table-wrap">
			<el-table v-loading="tableLoading" :data="tableData" size="small">
				<el-table-column label="关联商务合同名称" prop="name" align="center"></el-table-column>
				<el-table-column label="合同金额" prop="money" align="center"></el-table-column>
				<el-table-column label="客户名称" prop="customerName" align="center"></el-table-column>
				<el-table-column label="品牌名称" prop="brandName" align="center"></el-table-column>
				<el-table-column label="业务负责人" prop="businessPrincipal" align="center"></el-table-column>
				<el-table-column label="关联投放记录数" prop="putInNum" align="center"></el-table-column>
				<el-table-column label="回款状态" prop="returnStatus" align="center">
					<template slot-scope="scope">
							<span v-if="scope.row.returnStatus==1">未回款</span>
							<span v-else-if="scope.row.returnStatus==2">部分回款</span>
							<span v-else-if="scope.row.returnStatus==3">全部回款</span>
							<span v-else>暂无</span>
					</template>
				</el-table-column>
				<el-table-column label="合同状态" prop="status" align="center">
					<template slot-scope="scope">
							<span v-if="scope.row.returnStatus==1">启动审批中</span>
							<span v-else-if="scope.row.returnStatus==2">启动审批不通过</span>
							<span v-else-if="scope.row.returnStatus==3">进行中</span>
							<span v-else-if="scope.row.returnStatus==4">进行中（结案审核中）</span>
							<span v-else-if="scope.row.returnStatus==5">进行中（结案审核不通过）</span>
							<span v-else-if="scope.row.returnStatus==6">已结案</span>
							<span v-else-if="scope.row.returnStatus==7">进行中（关闭审核中）</span>
							<span v-else-if="scope.row.returnStatus==8">进行中（关闭审核不通过）</span>
							<span v-else-if="scope.row.returnStatus==9">已关闭</span>
							<span v-else>暂无</span>
					</template>
				</el-table-column>
				<el-table-column label="创建时间" prop="createTime" align="center"></el-table-column>
<!-- 				<el-table-column label="框架协议文件" prop="voucher" align="center">
				  <template slot-scope="scope">
					<a class="link" href="javascript:void(0);" @click="downloadFile(scope.row.voucher,'回款凭证')" :download="scope.row.voucher">回款凭证</a>
				  </template>
				</el-table-column> -->
				<!-- <el-table-column label="盖章状态" prop="status" align="center"></el-table-column> -->
				
<!-- 				<el-table-column label="操作" align="center">
					<template slot-scope="scope">
						
						<el-button type="text" size="small" @click="goSee(scope.row.id)">查看</el-button>
						<el-button type="text" size="small" @click="gzEdit(scope.row.id)">编辑</el-button>
						<el-button type="text" size="small" @click="sqgz(scope.row.id)">申请盖章</el-button>
						<el-button type="text" size="small" @click="gzInfo(scope.row.id)">盖章审批详情</el-button>
						<el-button type="text" size="small" @click="sqgz(scope.row.id)">重新申请盖章</el-button>
						<el-button type="text" size="small" @click="gz(scope.row.id)">删除</el-button>
					</template>
				</el-table-column> -->
			</el-table>

      <!-- 分页 -->
      <div class="pagination-wrap">
        <el-pagination background @size-change="sizeChange" @current-change="currentChange" :current-page.sync="page.pageNum" :page-sizes="[10, 20, 30, 40, 50, 100]" :page-size="page.pageSize"
          layout="sizes, prev, pager, next, jumper" :total="page.total">
        </el-pagination>
      </div>
      <!-- 分页 -->
    </div>
    <!-- 盖章审批详情 -->
    <el-dialog title="盖章审批详情" :visible.sync="Invoicedialog">
      <el-form :model="InvoiceForm" ref="InvoiceForm" :rules="rules" label-width="130px">
        <el-form-item label="直属主管审批人:" prop="bankSerialNumber" class="block-form-item w-32" style="width: 40%;">
          <el-input v-model="InvoiceForm.bankSerialNumber" disabled></el-input>
        </el-form-item>
        <el-form-item label="业务总监审批人:" prop="returnMoney" class="block-form-item w-32" style="width: 40%;">
          <el-input v-model="InvoiceForm.returnMoney" disabled></el-input>
        </el-form-item>
        <el-form-item label="审批状态:" prop="status" class="" style="width:40%;">
          <el-select v-model="InvoiceForm.status" class="w-100" disabled>
               <el-option v-for="(item,index) in rlList" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="审批备注:" prop="remark" class="block-form-item w-99">
          <el-input type="textarea" maxlength="300" show-word-limit v-model="InvoiceForm.remark" disabled></el-input>
        </el-form-item>
      </el-form>
    </el-dialog>
    <!-- 申请盖章 -->
    <el-dialog title="申请盖章" :visible.sync="sqVisible" width="30%">
	  <el-form :model="zfData" ref="zfData" :rules="rules" label-width="110px">
			<el-form-item label="合同附件:" prop="invoiceDetail" class="block-form-item">
				<el-upload  class="upload-demo" :action="'https://upload-z2.qiniup.com'" :before-upload="beforeUpload">
					<a style="display: block;" class="link" href="javascript:void(0);"  @click="downloadFile(InvoiceForm.voucher,InvoiceForm.voucher)" :download="InvoiceForm.voucher">{{InvoiceForm.voucher}}</a>
					<el-button  size="small" type="primary">上传合同附件</el-button>
				</el-upload>
			</el-form-item>
			<el-form-item label="盖章类型:" prop="returnType" class="block-form-item ">
			  <el-select v-model="InvoiceForm.returnType" class="w-100">
				  <el-option v-for="(item,index) in hkType" :label="item.label" :value="item.value"></el-option>
			  </el-select>
			</el-form-item>
			  <el-form-item label="盖章经办人:" prop="companyAddress" class="block-form-item w-16">
				<el-input :value="form.customerName">
				  <i slot="append"  class="iconfont icon-xialaxuanze_xialaduoxuan"></i>
				</el-input>
			  </el-form-item>
			  <div class="mar-c">
				<el-button type="primary" size="small" @click="invoiceVisible=false" :disabled="submitLoading">确定</el-button>
			  </div>
	  </el-form>
    </el-dialog>
    <!-- 认领记录 -->
    <el-dialog title="认领记录" :visible.sync="approveVisible" width="50%" v-loading="approveLoading">
		  <template>
		    <el-table
		      :data="rlData"
		      style="width: 100%">
		      <el-table-column prop="contractName" label="认领商务合同名称"  width="180"></el-table-column>
			  <el-table-column prop="claimMoney" label="认领回款金额"  width="180"></el-table-column>
			  <el-table-column prop="createUserName" label="认领操作人"  width="180"></el-table-column>
			  <el-table-column prop="createTime" label="认领操作时间"  width="180"></el-table-column>
			  <el-table-column prop="claimStatus" label="状态"  width="180">
				  <template slot-scope="scope">
						<span v-if="scope.row.claimStatus==0">已认领</span>
						<span v-else-if="scope.row.claimStatus==1">已作废</span>
				  </template>
			  </el-table-column>
			  <el-table-column label="操作" align="center">
			    <template slot-scope="scope">
			      <el-button type="text" size="small" @click="zfClick(scope.id)">作废</el-button>
			  	  <el-button type="text" size="small" @click='zfInfo(scope.row.id)'>作废详情</el-button>
			    </template>
			  </el-table-column>
		    </el-table>
		  </template>
		  <!-- 分页 -->
		  <div class="pagination-wrap">
		    <el-pagination background @size-change="rlSizeChange" @current-change="rlCurrentChange" :current-page.sync="rlpage.pageNum" :page-sizes="[10, 20, 30, 40, 50, 100]" :page-size="rlpage.pageSize"
		      layout="sizes, prev, pager, next, jumper" :total="rlpage.total">
		    </el-pagination>
		  </div>
    </el-dialog>
  </div>
</template>

<script>
import * as qiniu from "qiniu-js";
import { getGlList } from "./index.js";
import { mapGetters } from "vuex";
import validate from "@/util/validate";
import util from "@/util/util";
import { contractConfig } from "@/const/config/contract";
import InvoiceFormFields from "@/const/form/InvoiceForm";
import { billingConfig } from "@/const/config/billing";
export default {
  components: {

  },
  data() {
    // 开票金额判断
    var validPrice = (rule, value, callback) => {
      let money = this.remainingMoney;
      if (!validate.checkNull(value)) {
        let err = validate.checkAmount(value, money);
        if (err) {
          callback(new Error(err));
        }
        callback();
      }
      callback();
    };
    return {
	  sqVisible:false,//申请开关

	  hkid:'',//单个回款id
	  hkType:[
		  {label:'商务合同回款',value:1},
		  {label:'品牌合同回款',value:2},
	  ],//回款类型
	  rlList:[
		  {label:'未认领',value:1},
		  {label:'部分认领',value:2},
		  {label:'完全认领',value:3},
	  ],//认领状态1未认领 2部分认领 3完全认领
	  rlData:[],//认领记录
	  zfData:{},//作废信息
	  fileList: [],//凭证
      billingConfig,
      approveVisible: false,
      approveLoading: false,
	  Invoicedialog: false, //回款详情
	  approveTitle:false,
	  invoiceVisible: false,//作废详情
	  zftxVisible:false,//作废提醒
      /**
       * 开票提醒模块
       */
      isUploadFile: false, //是否上传
      hasCorrectIncome: false, //KOL收入+有花果收入=净收入
      hasRemainingMoney: false, //剩余金额大于可开票金额


      contractConfig: contractConfig,
      form: {
        nameOrCode: "",
        customerName: "",
        contractMoneyMin: "",
        contractMoneyMax: "",
        statusList: "",
      },
      InvoiceForm: {
			account: "",
			bankAccount: null,
			bankDeposit: "",
			bankSerialNumber: "",
			claimMoney: null,
			createTime: "",
			createUserId: "",
			createUserName: "test",
			deleteFlag: null,
			payeeName: "",
			payer: "",
			remark: "",
			returnMoney: 0,
			returnTime: "",
			returnType: 1,
			status: 1,
			voucher: "",
			waitClaimMoney: 0,
      },
      rules: {
        invoiceMoney: [
        ],
      },
      page: {
        pageNum: 1,
        pageSize: 10,
        total: 0,
		MaxMoney:null,//最大值
		MinMoney:null,//最小值
		bankNumber:'',//银行流水号
		payer:'',//付款方
		returnStatus:null,//认领状态
		returnType:null,//回款类型
      },
	  rlpage:{
		  pageNum: 1,
		  pageSize: 10,
		  total: 0,
	  },//认领列表分页
      submitLoading: false,
      tableData: [],
      tableLoading: false,
      /**
       * 业务负责人模块
       */
      adminListModal: false,
      adminPage: {
        pageSize: 10,
        pageNum: 1,
        total: 0,
      },
      adminForm: {
        queryString: "",
      },
      selectAdminId: null,
      selectAdmin: null,
      adminTable: [],
      adminTableLoading: false,
      pid: null,
    };
  },
  mounted() {
    this.getList();
  },
  computed: {
    ...mapGetters(["permissions", "dicts"]),
  },
  methods: {
	  //上传方法
	  beforeUpload(file) {
		 console.log(1111111,file)
		  qiniuToken()
			.then((res) => {
			  let that = this;
			  let fileName = Date.now() + file.name;
			  var observable = qiniu.upload(file, fileName, res.data);
			  observable.subscribe({
				next(res) {
				  console.log("upload...", res);
				},
				error(error) {
				  this.$message.error("上传失败");
				  console.log("error", error);
				},
				complete: (complete) => {
				  console.log("complete");
				  let qiniuBaseUrl = "https://yhgtk.fruitbloom.com.cn/";
				  this.$set(this.form, "fileName", file.name);
				  this.$set(this.form, "path", qiniuBaseUrl + complete.key);
				  console.log(qiniuBaseUrl + complete.key)

				},
			  });
			})
			.catch((error) => {});
		  return false;
	  },
	  //申请盖章or重新申请盖章
	  sqgz(id){
		this.sqVisible = true
	  },
	  
	  
	  //跳转认领
	  gzEdit(id){
		  let router = this.$router.resolve({
		    path: "/business/frameAccord/edit",
		    query: {
		      id: id,
		    },
		  });
		  window.open(router.href, "_blank");
	  },
	// 查看详情
	gzInfo(id){
	  this.Invoicedialog = true
	  // hkInfo(id)
	  //   .then((res) => {
	  // 			this.InvoiceForm  = res.data
	  //   })
	  //   .catch((err) => {
	  			
	  //   });
	},
	//打开认领记录
	openrlList(id){
			this.approveVisible = true
			this.hkid = id
			this.getRl();
	},
	// 获取认领记录
	getRl(){
		let obj = {
			id:this.hkid,
			pageNum:this.rlpage.pageNum,
			pageSize:this.rlpage.pageSize,
		}
		rlList(obj)
		  .then((res) => {
				console.log('我是认领记录',res)
				this.rlData = res.data
				this.rlpage.total = res.total;
				console.log('我是认领记录总数',this.rlpage.total)
		  })
		  .catch((err) => {
					
		  });
	},
	//点击作废
	zfClick(){
		        this.$alert('请联系财务操作作废', '作废提醒', {
		          confirmButtonText: '确定',
		          callback: action => {
					
		          }
		        });
	},
	//作废信息
	zfInfo(id){
		this.invoiceVisible = true
		zfInfoApi(id)
		  .then((res) => {
				console.log('我是作废信息',res)
				this.zfData = res.data
		  })
		  .catch((err) => {
					
		  });
	},
	// 上传凭证
	  handleRemove(file, fileList) {
		console.log(file, fileList);
	  },
	  handlePreview(file) {
		console.log(file);
	  },
	  handleExceed(files, fileList) {
		this.$message.warning(`当前限制选择 3 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
	  },
	  beforeRemove(file, fileList) {
		return this.$confirm(`确定移除 ${ file.name }？`);
	  },
    /**重新提交 */
    reSubmit(contractId) {
      this.$confirm("确认重新提交启动审批?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          reapply({ contractId }).then((res) => {
            this.$message.success("重新提交成功");
            this.getList();
          });
        })
        .catch(() => {});
    },
    /**
     * 业务负责人模块
     */
    //打开资源选择弹窗
    onOpenAdminSelectModal(username, id, pid) {
      if (username) {
        this.selectAdmin = {
          username,
          id,
        };
      } else {
        this.selectAdmin = null;
      }
      this.pid = pid;
      this.adminListModal = true;
    },
    //资源选择弹窗打开
    openAdminSelectModal() {
      this.adminForm.queryString = "";
      this.selectAdminId = null;
      this.onAdminSearch();
    },
    //资源标签删除
    onAdminTagClose() {
      this.selectAdmin = null;
      this.selectAdminId = null;
    },
    //资源弹窗关闭
    onConfirmAdminChoose() {
      if (this.selectAdmin) {
        let obj = {
          businessPrincipalId: this.selectAdmin.id,
          contractId: this.pid,
        };
        editAdmin(obj)
          .then((res) => {
            if (res.code == 1) {
              this.$message.success("分配成功！");
              this.getList();
            }
          })
          .catch((err) => {});
        this.adminListModal = false;
      } else {
        this.$message.error("不能删除业务负责人！");
      }
    },
    /**认领列表
     * 监听分页器每页显示的条数变化
     * @param val 条数
     */
    rlSizeChange(val) {
      this.rlpage.pageNum = 1;
      this.rlpage.pageSize = val;
      this.getRl();
    },
    /**认领列表
     * 监听页数变化
     * @param val 当前页数
     */
    rlCurrentChange(val) {
      this.rlpage.pageNum = val;
      this.getRl();
    },
    //资源搜索
    onAdminSearch() {
      this.adminPage.pageNum = 1;
      this.getAdminList();
    },
    //获取资源列表
    getAdminList() {
      let obj = {
        pageSize: this.adminPage.pageSize,
        pageNum: this.adminPage.pageNum,
      };
      if (this.adminForm.queryString && this.adminForm.queryString.trim()) {
        obj.usernameOrPhone = this.adminForm.queryString.trim();
      }
      this.adminTableLoading = true;
      listAdmin(obj)
        .then((res) => {
          this.adminTable = res.data || [];
          this.adminPage.total = res.total;
          this.adminTableLoading = false;
        })
        .catch((err) => {
          this.adminTable = [];
          this.adminPage.total = 0;
          this.adminTableLoading = false;
        });
    },
    //资源选择变化
    onChangeAdmin(val) {
      console.log(this.selectAdminId);
      this.selectAdmin = this.adminTable.find((v) => v.id == val);
    },

    //提交
    onSubmit() {
      this.$refs.InvoiceForm.validate((valid, obj) => {
        if (valid) {
          let f = util.deepClone(this.InvoiceForm);
          InvoiceAdd(f).then((res) => {
            if (res.code == 1) {
              this.$message.success("申请成功！");
              this.Invoicedialog = false;
              this.getList();
            }
          });
        } else {
          let a = Object.keys(obj).map((v) => {
            let text = "";
            if (!InvoiceFormFields.list[v] && v.lastIndexOf(".") !== -1) {
              let fieldInArray = v.substring(v.lastIndexOf(".") + 1, v.length);
              text = InvoiceFormFields.list[fieldInArray];
            } else {
              text = InvoiceFormFields.list[v];
            }
            return text;
          });
          this.$message.error(
            "表单不完整！请检查" + a.join("、") + "是否按要求填写"
          );
        }
      });
    },
    /**
     * 监听分页器每页显示的条数变化
     * @param val 条数
     */
    sizeChange(val) {
      this.page.pageNum = 1;
      this.page.pageSize = val;
      this.getList();
    },
    /**
     * 监听页数变化
     * @param val 当前页数
     */
    currentChange(val) {
      this.page.pageNum = val;
      this.getList();
    },

    // 搜索
    onSearch() {
      if (this.form.contractMoneyMin && this.form.contractMoneyMax) {
        if (
          parseInt(this.form.contractMoneyMin) >
          parseInt(this.form.contractMoneyMax)
        ) {
          this.$message.error("最小合同金额不能大于最大合同金额");
          return;
        }
      }
      this.page.pageNum = 1;
      this.getList();
    },
    // 获取列表
    getList() {
      this.tableLoading = true;
	  let obj = {
	  	id:this.$route.query.id,
	  	pageNum:this.page.pageNum,
	  	pageSize:this.page.pageSize,
	  }
      getGlList(obj)
        .then((res) => {
			console.log(res)
          this.tableData = res.data || [];
          this.page.total = res.total;
          this.tableLoading = false;
        })
        .catch((err) => {
			
        });
    },

    /**
     * 跳转到编辑页
     */
    toEdit(id) {
      let router = this.$router.resolve({
        path: "/business/contract/edit",
        query: {
          id: id,
        },
      });
      window.open(router.href, "_blank");
    },
    /**
     * 数字可读化
     * @param num 数字
     */
    readableNum(num) {
      if (!num && num !== 0) return "";
      return util.priceFormat(num);
    },
  },
  watch: {
    Invoicedialog(val) {
      if (!val) {
        this.InvoiceForm = {
          contractId: null, //合同ID
          customerName: "", //名称
          companyPhone: "", //电话
          companyAddress: "", //公司地址
          taxpayerId: "", //纳税人识别号
          customerBank: "", //客户开户行
          customerBankAccount: "", //客户银行账户
          invoiceMoney: "", //开票金额
          invoiceType: "", //发票类型
          invoiceDetail: "", //开票明细
          remark: "", //合同备注
        };
        this.$refs.InvoiceForm.clearValidate("invoiceMoney");
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.top-box span{
	margin-left: 20px;
}
.table-wrap{
	margin-top: 20px;
}
.mar-c {
  display: flex;
  justify-content: center;
}
.table-count {
  margin: 15px 0 10px;
}
// 列表item
.block-form-item {
  &.w-32 {
    display: inline-block;
    width: 32%;
    margin-right: 1%;
    height: 64px;
  }

  &.w-99 {
    width: 99%;
    margin-right: 1%;
  }
}
.yhg-dialog {
  .select-con {
    display: flex;
    .label {
      white-space: nowrap;
    }
    .select-tag {
      margin-right: 5px;
      margin-bottom: 5px;
    }
    .select-tag-text {
      display: inline-block;
      max-width: 86px;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
  .filter-con {
    display: flex;
    align-items: center;
    margin: 20px 0;
    width: 800px;
    .label {
      white-space: nowrap;
    }
    .search-btn {
      margin-left: 15px;
    }
  }
  .submit-con {
    margin-top: 20px;
    text-align: right;
  }
}
  .el-input-group__append {
    position: relative;
    width: 32px;
    height: 32px;
    border: none;
    background: #fff;
    padding: 0;
    color: #409eff !important;
    .iconfont {
      position: absolute;
      top: 0;
      left: 0;
	  right: 0;
	  bottom: 0;
	  margin: auto;
      font-size: 33px !important;
	   color: #409eff !important;
	   margin: 0 auto !important;
	   text-align: center !important;
    }
    cursor: pointer;
  }
.select-con {
  .el-tag .el-icon-close {
    top: -8px;
  }
}
.avue-view .cost-table {
  width: calc(50% + 100px);
  th {
    background: none;
    font-weight: normal;
    font-size: 14px;
  }
  .cell {
    padding-left: 0;
  }
}
.el-table .operate-column {
  vertical-align: text-top;
}
/deep/.el-dialog__header {
  border-bottom: 1px solid #ccc !important;
}
.invoiceList {
  display: flex;
  justify-content: space-between;
}
.mt-10 {
  margin-top: 10px;
}
</style>